import { createAsyncThunk } from '@reduxjs/toolkit'
import portfolioScoreService from '../core/service'

export const getScoreRangesCreditRisk = createAsyncThunk(
  'portfolioInsights/getScoreRangesCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      let res = await portfolioScoreService.getScoreRangesCreditRisk(params)
      res = res ? JSON.parse(JSON.stringify(res)) : res
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getScoreRangesPerformance = createAsyncThunk(
  'portfolioInsights/getScoreRangesPerformance',
  async (params, { rejectWithValue }) => {
    try {
      let res = await portfolioScoreService.getScoreRangesPerformance(params)
      res = res ? JSON.parse(JSON.stringify(res)) : res
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
